import * as React from "react";

/** Marks the tables of one route sheet whose sideways scroll is kept in step. */
export const SYNC_SCROLL_X = "route-sheet-sync-x";
/** Marks, among them, the shared header — the one that stays mounted and keeps its offset. */
export const SYNC_SCROLL_X_HEADER = "route-sheet-sync-x-header";

/**
 * The route sheet's header and each trip are tables of their own, each scrolling sideways:
 * whichever one is scrolled, the others follow, so the columns stay under their header. Tables
 * that mount later (another shift, a new trip) take the header's offset when `layoutKey` changes.
 */
export function useSyncedScrollX(listRef: React.RefObject<HTMLElement>, layoutKey: string) {
  React.useEffect(() => {
    const list = listRef.current;
    if (!list) return;
    const sync = (event: Event) => {
      const source = event.target as HTMLElement;
      if (!source.classList?.contains(SYNC_SCROLL_X)) return;
      list.querySelectorAll<HTMLElement>(`.${SYNC_SCROLL_X}`).forEach((table) => {
        if (table.scrollLeft !== source.scrollLeft) table.scrollLeft = source.scrollLeft;
      });
    };
    // Scroll doesn't bubble: listen in the capture phase.
    list.addEventListener("scroll", sync, true);
    return () => list.removeEventListener("scroll", sync, true);
  }, [listRef]);

  React.useLayoutEffect(() => {
    const list = listRef.current;
    const header = list?.querySelector<HTMLElement>(`.${SYNC_SCROLL_X_HEADER}`);
    if (!list || !header) return;
    list.querySelectorAll<HTMLElement>(`.${SYNC_SCROLL_X}`).forEach((table) => {
      if (table !== header) table.scrollLeft = header.scrollLeft;
    });
  }, [listRef, layoutKey]);
}
